import pino from 'pino';

const inferDefaultLogLevel = (): string => {
  if (process.env.NODE_ENV === 'test' && process.env.DEBUG_TEST == null) {
    return 'silent';
  }

  if (process.env.NODE_ENV === 'production') {
    return 'info';
  }

  return 'debug';
};

export const log = pino({ level: process.env.LOG_LEVEL || inferDefaultLogLevel() });



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/common/src/service/logger.ts